import React from 'react';
export class StateType {
}
export class Tabs extends React.PureComponent {
    constructor(props) {
        super(props);
        this.tabCache = {};
        this.isTabVertical = (direction = this.props.tabDirection) => direction === 'vertical';
        this.shouldRenderTab = (idx) => {
            const { prerenderingSiblingsNumber = 0 } = this.props;
            const { currentTab = 0 } = this.state;
            return currentTab - prerenderingSiblingsNumber <= idx && idx <= currentTab + prerenderingSiblingsNumber;
        };
        this.getOffsetIndex = (current, width, threshold = this.props.distanceToChangeTab || 0) => {
            const ratio = Math.abs(current / width);
            const direction = ratio > this.state.currentTab ? '<' : '>';
            const index = Math.floor(ratio);
            switch (direction) {
                case '<':
                    return ratio - index > threshold ? index + 1 : index;
                case '>':
                    return 1 - ratio + index > threshold ? index : index + 1;
                default:
                    return Math.round(ratio);
            }
        };
        this.getSubElements = () => {
            const { children } = this.props;
            let subElements = {};
            return (defaultPrefix = '$i$-', allPrefix = '$ALL$') => {
                if (Array.isArray(children)) {
                    children.forEach((child, index) => {
                        if (child.key) {
                            subElements[child.key] = child;
                        }
                        subElements[`${defaultPrefix}${index}`] = child;
                    });
                }
                else if (children) {
                    subElements[allPrefix] = children;
                }
                return subElements;
            };
        };
        this.state = {
            currentTab: this.getTabIndex(props),
        };
        this.nextCurrentTab = this.state.currentTab;
    }
    getTabIndex(props) {
        const { page, initialPage, tabs } = props;
        const param = (page !== undefined ? page : initialPage) || 0;
        let index = 0;
        if (typeof param === 'string') {
            tabs.forEach((t, i) => {
                if (t.key === param) {
                    index = i;
                }
            });
        }
        else {
            index = param || 0;
        }
        return index < 0 ? 0 : index;
    }
    componentWillReceiveProps(nextProps) {
        if (this.props.page !== nextProps.page && nextProps.page !== undefined) {
            this.goToTab(this.getTabIndex(nextProps), true);
        }
    }
    componentDidMount() {
        this.prevCurrentTab = this.state.currentTab;
    }
    componentDidUpdate() {
        this.prevCurrentTab = this.state.currentTab;
    }
    goToTab(index, force = false, newState = {}) {
        if (!force && this.nextCurrentTab === index) {
            return false;
        }
        this.nextCurrentTab = index;
        const { tabs, onChange } = this.props;
        if (index >= 0 && index < tabs.length) {
            if (!force) {
                onChange && onChange(tabs[index], index);
                if (this.props.page !== undefined) {
                    return false;
                }
            }
            this.setState(Object.assign({ currentTab: index }, newState));
        }
        return true;
    }
    tabClickGoToTab(index) {
        this.goToTab(index);
    }
    getTabBarBaseProps() {
        const { currentTab } = this.state;
        const { animated, onTabClick, tabBarActiveTextColor, tabBarBackgroundColor, tabBarInactiveTextColor, tabBarPosition, tabBarTextStyle, tabBarUnderlineStyle, tabs, } = this.props;
        return {
            activeTab: currentTab,
            animated: !!animated,
            goToTab: this.tabClickGoToTab.bind(this),
            onTabClick,
            tabBarActiveTextColor,
            tabBarBackgroundColor,
            tabBarInactiveTextColor,
            tabBarPosition,
            tabBarTextStyle,
            tabBarUnderlineStyle,
            tabs,
        };
    }
    renderTabBar(tabBarProps, DefaultTabBar) {
        const { renderTabBar } = this.props;
        if (renderTabBar === false) {
            return null;
        }
        else if (renderTabBar) {
            // return React.cloneElement(this.props.renderTabBar(props), props);
            return renderTabBar(tabBarProps);
        }
        else {
            return <DefaultTabBar {...tabBarProps}/>;
        }
    }
    getSubElement(tab, index, subElements, defaultPrefix = '$i$-', allPrefix = '$ALL$') {
        const key = tab.key || `${defaultPrefix}${index}`;
        const elements = subElements(defaultPrefix, allPrefix);
        let component = elements[key] || elements[allPrefix];
        if (component instanceof Function) {
            component = component(tab, index);
        }
        return component || null;
    }
}
Tabs.defaultProps = {
    tabBarPosition: 'top',
    initialPage: 0,
    swipeable: true,
    animated: true,
    prerenderingSiblingsNumber: 1,
    tabs: [],
    destroyInactiveTab: false,
    usePaged: true,
    tabDirection: 'horizontal',
    distanceToChangeTab: .3,
};



// WEBPACK FOOTER //
// ./components/tabs/rmc-tabs/Tabs.base.tsx